import React, { Component } from "react";
import $ from "jquery";
import * as Common from "../CommonControlls/CommonJs";
import MainLayout from "../CommonControlls/MainLayout";
import Topmenu from "../CommonControlls/Topmenubar";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { SelectHCF } from "../OfflineDb/IndexDbTranscSP";
import AlertModal from "../CommonControlls/AlertModal";
import { SyncConfig } from "../OfflineDb/ConfigDataSync";
import DropDown from "../CommonControlls/DropdownRendrer";

const mapStateToProps = (store) => {
	return store;
};

const mapDispatchToProps = (dispatch) => {
	return {
		ShowAlert: (Settings) => {
			dispatch({ type: "UpdateAlert", payload: Settings });
		},
		ShowLoader: (Isloading) => {
			dispatch({ type: "UpdateLoader", payload: Isloading });
		},
	};
};

class HCF_Add extends Component {
	constructor(props) {
		super(props);
		this.state = {
			Id: 0,

			alertModalData: {
				title: "",
				message: "",
				First_Callback: () => { },
				Second_Callback: () => { },
				type: 1,
			},

			ProvinceLoader: false,
			Provincelist: [],
			ProvinceId: 0,

			DistrictLoader: false,
			Districtlist: [],
			FilteredDistrictlist: [],
			DistrictId: 0,

			TehsilLoader: false,
			Tehsillist: [],
			FilteredTehsillist: [],
			TehsilId: 0,

			HCFTypelist: [
				{ id: "1-a", name: "BHU" },
				{ id: "1-b", name: "GP" },
				{ id: "2-a", name: "RHC" },
				{ id: "2-b", name: "PPM" },
			],
			HCFTypeId: 1,

			SrList: [],
			SrCompleteName: "",
			SrShortName: "",
			SrId: 0,
			FilteredSrs: [],

			active: false,

			category: "public",
			isMicroscope: false,
		};
	}

	HandleAutoSuggestValChange = (fieldId, value) => {
		this.setState({ [fieldId]: value }, () => {
			if (fieldId === "ProvinceId") {
				var TempArr = this.state.Districtlist;
				var filteredArr = TempArr.filter(function (obj) {
					return obj.provinceId === value;
				});
				const TempSrs = this.state.SrList;
				const filteredSrs = TempSrs.filter((el) => el.provinceid === value);

				this.setState({
					// FilteredDistrictlist: filteredArr,
					FilteredSrs: filteredSrs,
				});
			}
			if (fieldId === "SrId") {
				const tempDistricts = this.state.Districtlist;
				var filteredSelectedDistricts = tempDistricts.filter(
					(obj) => obj.subrecipientid === value
				);
				this.setState({
					FilteredDistrictlist: filteredSelectedDistricts,
				});
			}
			if (fieldId === "DistrictId") {
				var TempArr = this.state.Tehsillist;

				var filteredArr = TempArr.filter(function (obj) {
					return obj.districtId === value;
				});
				this.setState({
					FilteredTehsillist: filteredArr,
				});
			}
			if (fieldId === "HCFTypeId") {
				const category = String(value).charAt(2) === "b" ? "private" : "public";
				this.setState({ category });
			}
		});
	};

	handlePaste = (event) => {
		// Prevent the default paste behavior
		// Access the pasted text
		const pastedText = event.clipboardData.getData('text') || event.clipboardData.getData('text/plain');

		event.preventDefault();
		// Split the text into two parts
		const [part1, part2] = pastedText.split(','); // Change the delimiter as needed

		// Update the ref values for the fields
		$("#Latitude").val(part1);
		$("#Longitude").val(part2);
	};

	validateHCFName = (value) => {
		// Remove leading spaces
		const trimmedValue = value.trimStart();

		// Check if the first character is an alphabet
		if (trimmedValue.length > 0 && !/^[a-zA-Z]/.test(trimmedValue)) {
			return {
				isValid: false,
				message: "Name must start with an alphabet (A-Z or a-z)"
			};
		}

		return {
			isValid: true,
			message: ""
		};
	};

	handleHCFNameChange = (event) => {
		const value = event.target.value;
		const validation = this.validateHCFName(value);

		// Remove leading spaces automatically
		const trimmedValue = value.trimStart();
		event.target.value = trimmedValue;

		// Show validation message if invalid
		if (!validation.isValid) {
			this.props.ShowAlert({ Type: 0, Msg: validation.message });
			setTimeout(function () {
				$("#Alertmsgbtn").click();
			}, 50);
		}
	};

	handleHCFNameBlur = (event) => {
		const value = event.target.value;
		const validation = this.validateHCFName(value);

		if (!validation.isValid) {
			this.props.ShowAlert({ Type: 0, Msg: validation.message });
			setTimeout(function () {
				$("#Alertmsgbtn").click();
			}, 50);
		}
	};

	render() {
		return (
			<div>
				<AlertModal {...this.state.alertModalData} />
				<MainLayout />
				<div id="right-panel" class="right-panel">
					<Topmenu
						PageTitle={this.state.Id == 0 ? "Add BHU & RHC" : "Edit BHU & RHC"}
						isShowAddBtn={false}
					/>
					<div class="content">
						{/*
            <div class="PageHeader_Container">
                <h2>{this.state.Id==0?"Add BHU & RHC":"Edit BHU & RHC"}</h2>
            </div> */}

						<div class="card col-lg-8 col-md-8 col-sm-12 col-xs-12">
							<div class="card-body row">
								<div class="">
									<form onSubmit={this.SubmitForm} novalidate>
										<div class="row">
											<div class="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
												<label for="">
													<span style={{ color: "red" }}>* </span>Name
												</label>
												<input
													autocomplete="off"
													type="text"
													class="form-control"
													id="HCFName"
													placeholder="Enter Name"
													required
													onChange={this.handleHCFNameChange}
													onBlur={this.handleHCFNameBlur}
												/>
											</div>

											<div class="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
												<label for="">Contact</label>
												<input
													autocomplete="off"
													pattern="[0][0-9]{10}"
													type="text"
													class="form-control"
													id="Contact"
													placeholder="Enter contact - 03123456789"
												/>
											</div>

											<div class="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
												<label for="">DHIS2 Code</label>
												<input
													autocomplete="off"
													type="text"
													class="form-control"
													id="dhis2code"
													placeholder="Enter DHIS2 Code"
												/>
											</div>

											<div class="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
												<label for="">MIS Code</label>
												<input
													autocomplete="off"
													type="text"
													class="form-control"
													id="miscode"
													placeholder="Enter MIS Code"
												/>
											</div>

											<div class="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
												<label for="">
													<span style={{ color: "red" }}>* </span>Type
												</label>
												<DropDown
													multi={false}
													dropdownRenderer={false}
													create={false}
													onChange={this.HandleAutoSuggestValChange}
													Type="HCFTypeId"
													options={this.state.HCFTypelist}
													val={this.state.HCFTypeId}
													addPlaceholder=""
													// disabled={this.state.Id !== 0}
													loading={false}
													searchBy="name"
													labelField="name"
													valueField="id"
													contentRenderer={false}
													placeholder="Select"
													clearable={false}
												/>
											</div>

											<div class="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
												<label for="">
													<span style={{ color: "red" }}>* </span>Province
												</label>
												<DropDown
													multi={false}
													dropdownRenderer={false}
													create={false}
													onChange={this.HandleAutoSuggestValChange}
													Type="ProvinceId"
													options={this.state.Provincelist}
													val={this.state.ProvinceId}
													addPlaceholder=""
													disabled={false}
													loading={this.state.ProvinceLoader}
													searchBy="name"
													labelField="name"
													valueField="id"
													contentRenderer={false}
													placeholder="Select"
												/>
											</div>

											<div className="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
												<label htmlFor="">
													<span style={{ color: "red" }}>* </span>SR Name
												</label>
												<DropDown
													multi={false}
													dropdownRenderer={false}
													create={false}
													onChange={this.HandleAutoSuggestValChange}
													Type="SrId"
													options={this.state.FilteredSrs}
													val={this.state.SrId}
													addPlaceholder=""
													disabled={false}
													loading={this.state.SrLoader}
													searchBy="name"
													labelField="name"
													valueField="id"
													contentRenderer={false}
													placeholder="Select"
												/>
											</div>

											<div class="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
												<label for="">
													<span style={{ color: "red" }}>* </span>District
												</label>
												<DropDown
													multi={false}
													dropdownRenderer={false}
													create={false}
													onChange={this.HandleAutoSuggestValChange}
													Type="DistrictId"
													options={this.state.FilteredDistrictlist}
													val={this.state.DistrictId}
													addPlaceholder=""
													disabled={false}
													loading={this.state.DistrictLoader}
													searchBy="name"
													labelField="name"
													valueField="id"
													contentRenderer={false}
													placeholder="Select"
												/>
											</div>

											<div class="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
												<label for="">
													<span style={{ color: "red" }}>* </span>Tehsil
												</label>
												<DropDown
													multi={false}
													dropdownRenderer={false}
													create={false}
													onChange={this.HandleAutoSuggestValChange}
													Type="TehsilId"
													options={this.state.FilteredTehsillist}
													val={this.state.TehsilId}
													addPlaceholder=""
													disabled={false}
													loading={this.state.TehsilLoader}
													searchBy="name"
													labelField="name"
													valueField="id"
													contentRenderer={false}
													placeholder="Select"
												/>
											</div>

											<div className="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
												<label htmlFor="">
													<span style={{ color: "red" }}>* </span>Category
												</label>
												<input
													autocomplete="off"
													type="text"
													class="form-control"
													placeholder="Category"
													required
													disabled
													value={this.state.category}
												/>
											</div>

											<div class="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
												<label htmlFor="">Latitude</label>
												<input
													autocomplete="off"
													type="text"
													class="form-control"
													id="Latitude"
													placeholder="Enter Latitude"
													onPaste={this.handlePaste}
												/>
											</div>

											<div class="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
												<label htmlFor="">Longitude</label>
												<input
													autocomplete="off"
													type="text"
													class="form-control"
													id="Longitude"
													placeholder="Enter Longitude"
												/>
											</div>

											<div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
												<label for="">Address</label>
												<textarea
													autocomplete="off"
													class="form-control"
													id="Address"
													rows="3"
													placeholder="Enter address"
												></textarea>
											</div>

											<div className="formInput_Container col-md-2 mt-2 ml-3">
												<div className="text-center ">
													<label className="CheckBox_container ">
														<span>Microscope</span>
														<input
															type="checkbox"
															onChange={(e) =>
																this.setState({
																	isMicroscope: e.target.checked,
																})
															}
															checked={this.state.isMicroscope}
														/>
														<span className="CheckBox_checkmark"></span>
													</label>
												</div>
											</div>
											<div className="formInput_Container col-md-2 mt-2 ml-3">
												<div className="text-center ">
													<label className="CheckBox_container ">
														<span>Active</span>
														<input
															type="checkbox"
															onChange={(e) =>
																this.setState({ active: e.target.checked })
															}
															checked={this.state.active}
														/>
														<span className="CheckBox_checkmark"></span>
													</label>
												</div>
											</div>

											<div class="form_footer formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
												<button
													type="submit"
													id="Form_SaveBtn"
													class="btn btn_style1"
												>
													Save
												</button>
												<button
													type="button"
													id="Form_DeleteBtn"
													onClick={this.onDelete}
													hidden={this.state.Id === 0}
													class="btn btn_style2"
												>
													Delete
												</button>
												<Link to="/BHUAndRHC">
													<button
														type="button"
														id="Form_CancelBtn"
														class="btn btn_style3"
													>
														Cancel
													</button>
												</Link>

												{/* Hide button for reset */}
												<Link style={{ display: "none" }} to="/BHUAndRHC_Add">
													<button
														id="Form_ResetBtn"
														type="button"
														class="btn initial-btn Cancel-Form-btn Form_Btn"
													>
														Reset
													</button>
												</Link>
											</div>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}

	componentWillMount() {
		if (this.props.UserAuthentication.AuthToken === "") {
			this.props.history.push("/Login");
		}
	}

	componentDidMount() {
		Common.AddClassToMenueLink("MenuLink_HCFs");
		this.GetPageConfigData(() => {
			var Id = Common.GetId();
			if (Id !== 0) {
				this.selectHCFDetails(Id);
			}
		});
		this.SelectSubReciepents();
	}

	GetPageConfigData = (CallBack) => {
		this.props.ShowLoader({ Isloading: true });
		var d1 = $.Deferred();
		var d2 = $.Deferred();
		var d3 = $.Deferred();
		this.SelectProvinces(() => {
			d1.resolve();
		});
		this.SelectDistricts(() => {
			d2.resolve();
		});
		this.SelectTehsil(() => {
			d3.resolve();
		});

		$.when(d1, d2, d3).done(() => {
			this.props.ShowLoader({ Isloading: false });
			CallBack();
		});
	};
	SelectProvinces = (Callback) => {
		this.setState({ ProvinceLoader: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"GET",
			false,
			Common.APILinks.SelectAll_Province,
			{},
			(data) => {
				this.setState({
					ProvinceLoader: false,
					Provincelist: data.data,
				});
				Callback();
			},
			(error) => {
				this.setState({ ProvinceLoader: false });
				this.props.ShowAlert({ Type: 0, Msg: error });
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
				Callback();
			}
		);
	};
	SelectDistricts = (Callback) => {
		this.setState({ DistrictLoader: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"GET",
			false,
			Common.APILinks.SelectAll_District,
			{},
			(data) => {
				this.setState({
					DistrictLoader: false,
					Districtlist: data.data,
				});
				Callback();
			},
			(error) => {
				this.setState({ DistrictLoader: false });
				this.props.ShowAlert({ Type: 0, Msg: error });
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
				Callback();
			}
		);
	};
	SelectTehsil = (Callback) => {
		this.setState({ TehsilLoader: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"GET",
			false,
			Common.APILinks.SelectAll_Tehsil,
			{},
			(data) => {
				this.setState({
					TehsilLoader: false,
					Tehsillist: data.data,
				});
				Callback();
			},
			(error) => {
				this.setState({ TehsilLoader: false });
				this.props.ShowAlert({ Type: 0, Msg: error });
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
				Callback();
			}
		);
	};
	selectHCFDetails = (Id) => {
		this.props.ShowLoader({ Isloading: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"GET",
			false,
			Common.APILinks.GetAll_HCF,
			{},
			(resp) => {
				this.props.ShowLoader({ Isloading: false });
				const hcf = resp.data.find((d) => d.id === Id);
				if (resp === undefined) {
					this.props.ShowAlert({ Type: 0, Msg: "No record found." });
					setTimeout(() => {
						$("#Alertmsgbtn").click();
					}, 50);
					$("#Form_CancelBtn").click();
					return;
				}
				this.LoadDataInEditMode(hcf);
			},
			(error) => {
				this.props.ShowLoader({ Isloading: false });
				this.props.ShowAlert({ Type: 0, Msg: error });
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};
	SelectSubReciepents = () => {
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"GET",
			false,
			Common.APILinks.SelectALl_SubRecipient,
			{},
			(resp) => {
				if (resp.status) {
					this.setState({
						SrList: resp.data.map((d) => ({
							id: d.id,
							name: d.short_name,
							districtId: d.districtid,
							...d,
						})),
					});
				}
			}
		);
	};
	LoadDataInEditMode = (data) => {
		console.log('LoadDataInEditMode')
		console.log(data)
		const subrecpient = this.state.SrList.filter(
			(item) => item.districtid === data.districtId
		);

		const category = data.category;
		const HCFTypeId =
			category === "public" ? `${data.typeId}-a` : `${data.typeId}-b`;
		this.setState({
			Id: data.id,
			FilteredSrs: subrecpient,
			ProvinceId: data.provinceId,
			DistrictId: data.districtId,
			TehsilId: data.tehsilId,
			SrId: data.subRecipientId,
			HCFTypeId: HCFTypeId,
			category: category,
			isMicroscope: data.is_microscope,
			active: data.isActive,
			Latitude: data.latitude,
			Longitude: data.longitude,
		});
		$("#HCFName").val(data.name);
		$("#Contact").val(data.contact);
		$("#dhis2code").val(data.dhis2code);
		$("#miscode").val(data.miscode);
		$("#Address").val(data.address);
		$("#Latitude").val(data.latitude);
		$("#Longitude").val(data.longitude);
	};
	ResetForm = () => {
		this.setState({
			Id: 0,
			ProvinceId: 0,
			DistrictId: 0,
			TehsilId: 0,
			HCFTypeId: 1,
		});
		$("#HCFName").val("");
		$("#Contact").val("");
		$("#dhis2code").val("");
		$("#miscode").val("");
		$("#Address").val("");
		$("#Latitude").val("");
		$("#Longitude").val("");
	};
	SubmitForm = (e) => {
		e.preventDefault();

		// Validate HCF Name
		const hcfName = $("#HCFName").val();
		const nameValidation = this.validateHCFName(hcfName);
		if (!nameValidation.isValid) {
			this.props.ShowAlert({ Type: 0, Msg: nameValidation.message });
			setTimeout(function () {
				$("#Alertmsgbtn").click();
			}, 50);
			return;
		}

		if (this.state.ProvinceId === 0) {
			this.props.ShowAlert({ Type: 0, Msg: "Please select province" });
			setTimeout(function () {
				$("#Alertmsgbtn").click();
			}, 50);
			return;
		}
		if (this.state.DistrictId === 0) {
			this.props.ShowAlert({ Type: 0, Msg: "Please select district" });
			setTimeout(function () {
				$("#Alertmsgbtn").click();
			}, 50);
			return;
		}
		if (this.state.TehsilId === 0) {
			this.props.ShowAlert({ Type: 0, Msg: "Please select tehsil" });
			setTimeout(function () {
				$("#Alertmsgbtn").click();
			}, 50);
			return;
		}
		this.props.ShowLoader({ Isloading: true });
		const SubRecipient = this.state.SrList.find(
			(d) => d.id === this.state.SrId
		);
		var Parameters = {
			id: this.state.Id,
			name: $("#HCFName").val(),
			contact: $("#Contact").val(),
			dhis2code: $("#dhis2code").val(),
			miscode: $("#miscode").val(),
			address: $("#Address").val(),
			Latitude: $("#Latitude").val(),
			Longitude: $("#Longitude").val(),
			districtId: this.state.DistrictId,
			provinceId: this.state.ProvinceId,
			tehsilId: this.state.TehsilId,
			typeId: String(this.state.HCFTypeId).charAt(0),
			is_microscope: this.state.isMicroscope,
			category: this.state.category,
			SubRecipientId: this.state.SrId,
			SubRecipient_CompleteName: SubRecipient.complete_name,
			SubRecipient_ShortName: SubRecipient.short_name,
			isActive: this.state.active,
		};
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Post",
			false,
			this.state.Id === 0
				? Common.APILinks.Save_HCF
				: Common.APILinks.Update_HCF,
			JSON.stringify(Parameters),
			(resp) => {
				if (resp.status) {
					SyncConfig(
						() => {
							if (this.state.Id !== 0) $("#Form_ResetBtn").click();
							this.ResetForm();
							this.props.ShowLoader({ Isloading: false });
							this.props.ShowAlert({ Type: 1, Msg: "Saved successfully" });
							setTimeout(() => {
								$("#Alertmsgbtn").click();
							}, 50);
						},
						() => {
							if (this.state.Id !== 0) $("#Form_ResetBtn").click();
							this.ResetForm();
							this.props.ShowLoader({ Isloading: false });
							this.props.ShowAlert({
								Type: 0,
								Msg: "Error in sync, please reload the page",
							});
							setTimeout(function () {
								$("#Alertmsgbtn").click();
							}, 50);
						}
					);
				} else {
					this.props.ShowLoader({ Isloading: false });
					this.props.ShowAlert({ Type: 0, Msg: resp.message });
					setTimeout(() => {
						$("#Alertmsgbtn").click();
					}, 50);
				}
			},
			(error) => {
				this.props.ShowLoader({ Isloading: false });
				this.props.ShowAlert({
					Type: 0,
					Msg: "Something went wronge, please try again.",
				});
				setTimeout(() => {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};
	onDelete = () => {
		this.setState(
			{
				alertModalData: {
					title: "Delete HCF",
					message: "Are you sure you want to delete this record.",
					First_Callback: () => {
						$("#Generic-modal-CloseBtn").click();
						this.DeleteRecord();
					},
					Second_Callback: () => {
						$("#Generic-modal-CloseBtn").click();
					},
					type: 1,
				},
			},
			() => {
				$("#Show_ArletModal").click();
			}
		);
	};
	DeleteRecord = () => {
		this.props.ShowLoader({ Isloading: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Get",
			false,
			Common.APILinks.Delete_HCF,
			{ Id: this.state.Id },
			(Result) => {
				if (Result.status) {
					SyncConfig(
						() => {
							$("#Form_CancelBtn").click();
							this.props.ShowLoader({ Isloading: false });
							this.props.ShowAlert({ Type: 1, Msg: "Deleted Successfully." });
							setTimeout(function () {
								$("#Alertmsgbtn").click();
							}, 50);
						},
						() => {
							this.props.ShowLoader({ Isloading: false });
							this.props.ShowAlert({
								Type: 0,
								Msg: "Error in sync, please reload the page",
							});
							setTimeout(function () {
								$("#Alertmsgbtn").click();
							}, 50);
						}
					);
				} else {
					this.props.ShowLoader({ Isloading: false });
					this.props.ShowAlert({ Type: 0, Msg: Result.message });
					setTimeout(function () {
						$("#Alertmsgbtn").click();
					}, 50);
				}
			},
			(error) => {
				this.props.ShowLoader({ Isloading: false });
				this.props.ShowAlert({
					Type: 0,
					Msg: "Something went wronge, please try again.",
				});
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(HCF_Add);
